import { find, get, isEmpty } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc ServiceNow defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ServiceNowService } from 'services/serviceNow';
 *
 * // create service instance and send/cancel request
 * const serviceNowService = new ServiceNowService();
 * const result = await serviceNowService.fetchData( '<user-id>' ); // fetch data
 * serviceNowService.cancel(); // cancel an active request
 */
export class ServiceNowService extends HttpService {

    // make request and fetch form data
    async fetchForm( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            const fields = getVisibleItems( response.body.component.structure.fields, response.body.component.visibility );
            const rxDetails = find( fields, { name: 'rxDetails' }, {} );

            if ( ! isEmpty( rxDetails ) ) {
                rxDetails.config.subFields = getVisibleItems( rxDetails.config.subFields, response.body.component.visibility );
            }

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    options: response.body.component.data.options,
                    values: response.body.component.data.state.values,
                    actions: response.body.component.structure.actions,
                    fields
                }
            };
            
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

     // submit form data
    async submitFormData( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            const status = get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE );

            if ( SERVICE_RESPONSE_STATUS.FAILURE === status ) {
                return {
                    status,
                    data: get( response, 'body.component.data', {} )
                };
            }
    
            return {
                status,
                data: {
                    data: get( response, 'body.component.data', {} ),
                    ...get( response, 'body.component.structure', {} )
                }

            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
